import { darkTheme } from './dark.js'
import { lightTheme } from './light.js'

module.exports = {
  darkTheme,
  lightTheme,
}
